<template>
  <div class="shop-more-details">
    <div class="content-scroll-wrapper">
      <h1 class="shop-name" v-text="title"></h1>
      <ul class="details-desc-wrapper">
        <li
          class="details-item"
          v-for="(item, index) in list"
          :key="'item' + index"
          :class="{'no-container': item.noContainer}"
        >
          <div class="left-box">
            <i :class="item.icon"></i>
          </div>
          <div class="details-item-content">
            <p class="item-title" v-text="item.title"></p>
            <dl class="content-box">
              <li
                class="content-item"
                v-for="(desc, index) in item.descList"
                :key="'desc' + index"
              >
                <p
                  class="content-item-title"
                  v-if="desc.title"
                  v-text="desc.title"
                ></p>
                <p
                  class="content-item-desc"
                  v-for="(content, index) in desc.content"
                  :key="'content' + index"
                >
                  {{ content.text }}
                  <span
                    class="view-btn"
                    v-if="content.viewName"
                    @click="openUrl(content.viewUrl)"
                  >
                    <span class="content">{{content.viewName}}</span>
                    <i class="icon-outline_entrance"></i>
                  </span>
                </p>
              </li>
            </dl>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/**
 * list: [{
    title: 'Delivery Method',
    icon: 'icon-filled_delivery',
    noContainer: true, // 非独立容器 多个内容组合时使用
    descList: [{
      title: '',
      content: [{
        text: disclaimer.desc,
        viewName: 'Enter',
        viewUrl: disclaimer.url
      }]
    }]
  }]
 */
export default {
  name: 'ShopMoreDetails',
  components: {

  },
  props: {
    title: String,
    list: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  mounted() {},
  methods: {
    openUrl(url) {
      url && window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>